import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { useWave } from "@/hooks/useWave";
import { DefaultWaveWinnersDrop } from "./DefaultWaveWinnerDrop";
import { MemesWaveWinnersDrop } from "./MemesWaveWinnerDrop";
interface WaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveWinnersDrop: React.FC<WaveWinnersDropProps> = t0 => {
  const $ = _c(7);
  const {
    winner,
    wave,
    onDropClick
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t1;
    if ($[0] !== onDropClick || $[1] !== wave || $[2] !== winner) {
      t1 = <MemesWaveWinnersDrop winner={winner} wave={wave} onDropClick={onDropClick} />;
      $[0] = onDropClick;
      $[1] = wave;
      $[2] = winner;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== onDropClick || $[5] !== winner) {
    t1 = <DefaultWaveWinnersDrop winner={winner} onDropClick={onDropClick} />;
    $[4] = onDropClick;
    $[5] = winner;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};